module.exports = __webpack_public_path__ + "e13f1c19ec8fe1bbd3282d551beff2ba.svg";